import { render, staticRenderFns } from "./JitsiMeeting.vue?vue&type=template&id=4e19c731&"
import script from "./JitsiMeeting.vue?vue&type=script&lang=js&"
export * from "./JitsiMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e19c731')) {
      api.createRecord('4e19c731', component.options)
    } else {
      api.reload('4e19c731', component.options)
    }
    module.hot.accept("./JitsiMeeting.vue?vue&type=template&id=4e19c731&", function () {
      api.rerender('4e19c731', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/Meeting/JitsiMeeting.vue"
export default component.exports